// extracted by mini-css-extract-plugin
export default {"centeringContainer":"btdtzT","separator":"PBkyWy","container":"t_xtVY"};